'use strict';

window.TES = window.TES || {};

window.TES.NagFooter = function (user) {
  var userData;

  if (window.Cookies('TESCookieV2')) {
    var cookieValue = window.Cookies('TESCookieV2').split('.')[1];
    var decodedCookieValue = (typeof atob !== 'undefined') ? atob(cookieValue) : Base64.decode(cookieValue);
    userData = JSON.parse(decodedCookieValue);
  }

  var twoYears = 2 * 365 * 86400;
  var aMonth = 30 * 24 * 60 * 60;
  var aDay = 24 * 60 * 60;
  var cookieName = 'nagfooter';
  var apiAck = '/api/nag/v3/ack';
  var apiCheck = '/api/nag/v3/check';
  var apiDebug = '/api/nag/v3/debug';
  var self = this;
  var userId = (user && +user.getId()) || (userData && userData.userId) || null;
  var userIdOrUnauth = userId || 'unauth';

  function browserIsSupported() {
    return !!jQuery.fn.jquery;
  }

  function naggedRecently() {
    return window.Cookies.get(cookieName) === userIdOrUnauth + '';
  }

  function silenceFor(expires) {
    window.Cookies.set(cookieName, userIdOrUnauth, {expires: expires});
  }

  function updateProfile(nagId, actioned) {
    var url = apiAck + '/' + userIdOrUnauth + '/' + nagId;
    jQuery.ajax(url, {
      type: 'DELETE',
      headers: {'x-csrf-token': window.Cookies.get('csrf')}
    });
  }

  function fetchContent(nagProvider, callback) {
    jQuery.ajax(nagProvider, {
      type: 'GET',
      dataType: 'html',
      success: function (content) {
        var nagId = jQuery(content).data('nag-id');
        callback(null, nagId, content);
      },
      error: callback
    });
  }

  function trackShow(nagName, isDebug) {
    if (!isDebug) {
      _mz.emit(_mze.DISPLAY, {
        module: {
          type: 'nag-footer',
          name: nagName
        }
      });
    } else {
      console.log('nag-footer show', nagName);
    }
  }

  function trackClose(nagName, isDebug) {
    if (!isDebug) {
      _mz.emit(_mze.CLOSE, {
        module: {
          type: 'nag-footer',
          name: nagName
        }
      });
    } else {
      console.log('nag-footer close', nagName);
    }
  }

  function trackAccept(nagName, payload, isDebug) {
    if (!isDebug) {
      _mz.emit(_mze.ACCEPT, {
        module: {
          type: 'nag-footer',
          name: nagName
        },
        payload: payload || {}
      });
    } else {
      console.log('nag-footer accept', nagName, payload);
    }
  }

  function render(nagId, content, isDebug) {
    var jQueryContent = jQuery(content);
    if(jQueryContent.is('.nag-box--top, .nag-box--thin-top')) {
      // we need the html to push the content down as it's not fixed
      jQuery('body').prepend(jQueryContent);
    } else {
      jQueryContent.appendTo('body');
    }
    var nag = jQuery('.nag-footer, .js-nag-box');
    self.nagId = nagId;
    trackShow(nagId, isDebug);
    jQuery('.nag-close, .js-nag-box__close').on('click', nag, function () {
      trackClose(nagId, isDebug);
      self.close(nagId, nag);
    });
    jQuery('.nag-accept, .js-nag-box__btn-accept').on('click', nag, function () {
      trackAccept(nagId, jQuery(this).data('payload'), isDebug);
      self.close(nagId, nag, true);
    });
    jQuery('.js-nag-box__select-accept').on('blur', nag, function () {
      var selectValue = jQuery(this).val();
      if (selectValue !== 'default') {
        trackAccept(nagId, selectValue, isDebug);
        self.close(nagId, nag, true);
      }
    });
  }

  this.close = function (nagId, nag, actioned) {
    nag.remove();
    var addendumSuccess = jQuery('.nag-addendum-success, .js-nag-box-addendum');
    if (addendumSuccess.length && actioned) {
      addendumSuccess.show();
      addendumSuccess.removeClass('hide');
      addendumSuccess.find('.nag-close, .js-nag-box__close').on('click', nag, function () {
        addendumSuccess.remove();
      });
    }
    silenceFor(aDay);
    updateProfile(nagId, actioned);
  };

  this.show = function () {
    if (!browserIsSupported()) return;
    if (naggedRecently()) return;
    fetchContent(apiCheck + '/' + userId, function (err, nagId, content) {
      if (err) new Error(err && err.responseCode);
      if (!content) return;
      if (!nagId) throw 'Content missing id; may be server or network error or incorrect HTML';
      render(nagId, content);
    });
  };

  this.debug = function (nagId) {
    fetchContent(apiDebug + '/' + nagId, function (err, nagId, content) {
      if (err) new Error(err && err.responseCode);
      if (!content) return;
      render(nagId, content, true);
    });
  };
};

if(window.TES.preventNagFooterOnLoad !== true) {
  window.addEventListener("load", function load(event) {
    window.removeEventListener("load", load, false);
    new window.TES.NagFooter(window.TES.user).show();
  }, false);
}
